import React from 'react';
import { Navigate } from 'react-router-dom';
import { getTokenFromLocalStorage } from 'util/localStorageHelper';
import useUserStore from 'store/useUserStore';
import { ROUTES } from 'util/Constants';

export const PublicOverviewGuard = ({ children }: Readonly<{ children?: React.ReactNode }>) => {
    const userToken = getTokenFromLocalStorage();
    const { userInfo, isOnboardingUser } = useUserStore();

    // If user is logged in, redirect them to appropriate page
    if (userToken && userInfo) {
        if (isOnboardingUser()) {
            return <Navigate to={ROUTES.ONBOARDING} replace />;
        }
        return <Navigate to={ROUTES.MAIN} replace />;
    }

    // If no token, show public overview
    return <>{children}</>;
};
